import { useSupabaseQuery } from './useSupabaseQuery';

/**
 * Listagem global de imóveis.
 * Traz lote → area (aninhado) e proprietários (empresa XOR contato).
 * Schema: imovel_proprietarios.proprietario_empresa_id / proprietario_contato_id.
 */
export function useImoveis() {
  return useSupabaseQuery(
    (sb) =>
      sb
        .from('imoveis')
        .select(
          `
            id, nome, matricula, inscricao_municipal,
            endereco, numero, complemento, bairro, cidade, uf, cep,
            area_terreno_m2, area_construida_m2, tipo_uso_atual, situacao,
            status_juridico, onus_descricao, fonte_dados,
            created_at, updated_at, lote_id,
            lotes:lote_id ( id, nome, area_id, areas:area_id ( id, nome ) ),
            imovel_proprietarios (
              id, percentual_participacao, tipo_propriedade,
              empresa:empresas!imovel_proprietarios_proprietario_empresa_id_fkey ( id, empresa, company_name ),
              contato:contatos!imovel_proprietarios_proprietario_contato_id_fkey ( id, first_name, last_name )
            )
          `
        )
        .order('updated_at', { ascending: false, nullsFirst: false }),
    []
  );
}
